import { render, staticRenderFns } from "./during-vote.vue?vue&type=template&id=74c0dc1a&scoped=true&"
import script from "./during-vote.vue?vue&type=script&lang=js&"
export * from "./during-vote.vue?vue&type=script&lang=js&"
import style0 from "./during-vote.vue?vue&type=style&index=0&id=74c0dc1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c0dc1a",
  null
  
)

export default component.exports